import { render, staticRenderFns } from "./indexLeft03.vue?vue&type=template&id=45fa31d7&scoped=true&"
import script from "./indexLeft03.vue?vue&type=script&lang=js&"
export * from "./indexLeft03.vue?vue&type=script&lang=js&"
import style0 from "./indexLeft03.vue?vue&type=style&index=0&id=45fa31d7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fa31d7",
  null
  
)

export default component.exports